import './noData.scss';
import React from 'react';

export default function NoData({ placeholder = '暂无数据' }) {
    return (
        <div className="no-data-wrap">
            <div className="no-data">
                <i className="iconfont icon-zu"></i>
                <p>{placeholder}</p>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/noData/NoData.jsx